var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"AccuracyWindow\">\n<div class=\"AccuracyWindow-crosshairv\"></div>\n<div class=\"AccuracyWindow-crosshairh\"></div>\n</div>";
var id1="accuracy.window.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/accuracy-window/accuracy.window.html
// module id = 574
// module chunks = 0